// extracted by mini-css-extract-plugin
module.exports = {"adtechbanner":"AdtechBanner_adtechbanner__APxRd"};